module.exports = __webpack_public_path__ + "img/1532180947.b0b591ba.jpg";